<template>
  <date-picker v-model="dateValue" :placeholder="placeholder" :config="config" @dp-change="changeValue"></date-picker>
</template>

<script>
import dateUtils from '@/components/utils/DateUtils.js'
import moment from 'moment-timezone';
export default {
  name: 'SelectorDate',
  data() {
    return {
        dateValue : null,
    };
  },
  props: {
    placeholder: "",
    config: null,
    /**
     * valueType = 'string' || 'number' || 'date'
     */
    valueType: null,
    value: null,
  },
  watch: {
      value: {
          handler(newValue, oldValue){
            if(newValue && typeof newValue == 'number'){
                this.dateValue = new Date(newValue);      
            }else{
                this.dateValue = newValue;
            }               
          }
      }
  },
  methods: {
        changeValue () {
            if(!this.dateValue){    
                this.$emit("input", null);
                this.$emit("change", null);       
                return;
            }            
            if(this.config.format){
                if(typeof this.value == 'string'){
                    this.$emit("input", this.dateValue);
                    this.$emit("change", this.dateValue);
                }else if(typeof this.value == 'number'){
                    this.$emit("input", moment(this.dateValue, this.config.format).unix()*1000);
                    this.$emit("change", moment(this.dateValue, this.config.format).unix()*1000); 
                }else if(typeof this.value == 'date'){
                    this.$emit("input", new Date(moment(this.dateValue, this.config.format).unix()*1000));
                    this.$emit("change", new Date(moment(this.dateValue, this.config.format).unix()*1000)); 
                }else {
                    if(this.valueType && this.valueType == 'number'){
                        this.$emit("input", moment(this.dateValue, this.config.format).unix()*1000);
                        this.$emit("change", moment(this.dateValue, this.config.format).unix()*1000); 
                    }else if(this.valueType && this.valueType == 'date'){
                        this.$emit("input", new Date(moment(this.dateValue, this.config.format).unix()*1000));
                        this.$emit("change", new Date(moment(this.dateValue, this.config.format).unix()*1000));   
                    }else{
                        this.$emit("input", this.dateValue);
                        this.$emit("change", this.dateValue);
                    }
                }   
            }else{
                this.$emit("input", this.dateValue);
                this.$emit("change", this.dateValue);
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/selector/date/index.vue